import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import enTranslation from '../locales/en/translation.json';
import enLegalPrivacy from '../locales/en/legalPrivacy.json';
import ptTranslation from '../locales/pt/translation.json';
import ptLegalPrivacy from '../locales/pt/legalPrivacy.json';

const resources = {
  en: {
    translation: { ...enTranslation, ...enLegalPrivacy },
  },
  pt: {
    translation: { ...ptTranslation, ...ptLegalPrivacy },
  },
};

// Get saved language from localStorage or use browser language
const savedLanguage = localStorage.getItem('quizter-language');
const browserLanguage = navigator.language.split('-')[0];
const defaultLanguage = savedLanguage || (browserLanguage === 'pt' ? 'pt' : 'en');

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: defaultLanguage,
    fallbackLng: 'en',
    debug: false,
    
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'quizter-language'
    },

    interpolation: {
      escapeValue: false // React already does escaping
    },

    // Only load supported languages
    supportedLngs: ['en', 'pt'],
    
    // React specific options
    react: {
      useSuspense: false,
      bindI18n: 'languageChanged',
      bindI18nStore: 'added removed',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
    }
  });

export default i18n; 